import actions from './onlineSales.types.js';

const initialState = {
    loading: false,
    loadingOrder: false,
    loadingBrand: false,
    loadingOutlet: false,
    errMsg: '',
    loadingDetail: false,
    loadingHistory: false,
    loadingPoints: false,

    cart: [],
    detail: {},
    waiver: {},
    children: [],
    selectedDate: new Date(),
    selectedDetailCurrentDate: new Date(),
    selectedDetailDate: new Date(),
    selectedDetailTimeslot: {},
    selectedDetailRooms: [],
    selectedAddonsDetail: [],
    brands: [],
    outlets: [],
    historyTransactions: [],
    historyDetail: {},
    loyaltyTiers: [],
    rewardsData: {},
    pointHistory: [],
    redeemHistory: [],
    page: JSON.parse(localStorage.getItem('page') || '{}'),
    currentTheme: JSON.parse(localStorage.getItem('page') || '{}')['theme'] || {},
};

export default function onlineSalesReducer(state = initialState, action) {
    switch (action.type) {
        case actions.SET_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
